const secondsPerCharacter = .01;

class TickertapeController {
  constructor($sce, $element) {
    this.$sce = $sce;
    this.$element = $element;
  }

  get tickerStyle() {
    const width = this.$element[0].firstChild.clientWidth;
    const animationTime =  this.article && this.article.__content ? width * secondsPerCharacter : 30;
    return {
      'animation-duration': `${animationTime}s`
    }
  }

  get content() {
    return this.article && this.article.__content ?
      this.$sce.trustAsHtml(this.article.__content) : '';
  }
}

export default TickertapeController;



// WEBPACK FOOTER //
// ./client/app/components/content-types/tickertape/tickertape.controller.js